/**
 * Any INTERNAL RM24 role.
 *
 * admin / dispatcher / finance are hats one person wears, not separate jobs, so
 * they are authorised identically — on the server, in the security rules and
 * here. Comparing roles by hand is what produced the differences this replaces:
 * a screen that offered an action to a dispatcher but not to finance locked the
 * same person out depending on which role their account happened to carry.
 *
 * The roles remain distinct VALUES for the day a narrower one is needed again;
 * what is gone is the difference in what they may do. External roles
 * (`worker`, `client_user`, `partner_admin`) are never staff.
 */

import type { UserRole } from '@rendimees24/shared-types';

const STAFF: ReadonlySet<string> = new Set(['admin', 'dispatcher', 'finance']);

export function isStaff(role: UserRole | string | null | undefined): boolean {
  return !!role && STAFF.has(role);
}
